import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalTermoUsoAdminComponent } from './modal-termo-uso-admin.component';
import { MaterialModule } from 'src/app/material.module';


@NgModule({
  declarations: [
    ModalTermoUsoAdminComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
  ],
  exports: [ModalTermoUsoAdminComponent]
})
export class ModalTermoUsoAdminModule { }
